module.exports = __webpack_public_path__ + "img/warning_circle.e4dbb781.png";